/**
 * @param {DataSearchGroupApiProps} group
 * @param {TermsApiProps} terms
 * @returns {DataSearchGroup}
 */
function mapDataSearchGroup(group, terms) {
  return {
    id: group.categoryId,
    count: group.count,
    terms: group.terms.map((term) => {
      const foundData = terms.terms.find((t) => t.id === term.id);
      return {
        id: term.id,
        label: foundData?.title ?? '[unknown]',
        count: term.count,
        description: foundData?.description,
        itemIds: term.itemIds,
        subgroup: term.subgroup
          ? mapDataSearchGroup(term.subgroup, terms)
          : undefined,
      };
    }),
  };
}

export default mapDataSearchGroup;
